"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUpgradeData = exports.createLazyLoadedUpgradeData = exports.createStaticUpgradeData = exports.createRenderBlockingUpgradeData = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _q = _interopRequireDefault(require("q"));

var _getPropertyProduct = require("ui-addon-upgrades/_core/common/data/upgradeData/transformers/getPropertyProduct");

var _getPropertySource = require("ui-addon-upgrades/_core/common/data/upgradeData/transformers/getPropertySource");

var _getPropertyType = require("ui-addon-upgrades/_core/common/data/upgradeData/transformers/getPropertyType");

var _getPropertyCampaign = require("ui-addon-upgrades/_core/common/data/upgradeData/transformers/getPropertyCampaign");

var _getPropertyTrialId = require("ui-addon-upgrades/_core/common/data/upgradeData/transformers/getPropertyTrialId");

var _getPropertyRepInfo = require("ui-addon-upgrades/_core/common/data/upgradeData/transformers/getPropertyRepInfo");

var _getPropertyPurchaseMotionEligibility = require("ui-addon-upgrades/_core/common/data/upgradeData/transformers/getPropertyPurchaseMotionEligibility");

var _getPropertySeatedProductOwned = require("ui-addon-upgrades/_core/common/data/upgradeData/transformers/getPropertySeatedProductOwned");

var _upgradeProducts = require("./properties/upgradeProducts");

var RENDER_BLOCKING_PROPERTY_GETTERS = [_getPropertyProduct.getPropertyProduct, _getPropertySource.getPropertySource, _getPropertyType.getPropertyType, _getPropertyCampaign.getPropertyCampaign, _getPropertyTrialId.getPropertyTrialId];
var STATIC_PROPERTY_GETTERS = [_getPropertyProduct.getPropertyProduct, _getPropertySource.getPropertySource, _getPropertyType.getPropertyType, _getPropertyCampaign.getPropertyCampaign];
var LAZY_LOADED_PROPERTY_GETTERS = [_getPropertyRepInfo.getPropertyRepInfo, _getPropertyPurchaseMotionEligibility.getPropertyPurchaseMotionEligibility, _getPropertySeatedProductOwned.getPropertySeatedProductOwned];

var _createUpgradeData = function _createUpgradeData(propertyGetters, upgradeData, upgradeSource) {
  var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var correctedUpgradeData;

  if (upgradeData.upgradeProduct === _upgradeProducts.upgradeProducts.MARKETING_STARTER) {
    correctedUpgradeData = (0, _extends2.default)({}, upgradeData, {
      upgradeProduct: _upgradeProducts.upgradeProducts.MARKETING_STARTER_EMAIL
    });
  } else {
    correctedUpgradeData = upgradeData;
  }

  var properties = propertyGetters.map(function (propertyGetter) {
    return propertyGetter(correctedUpgradeData, upgradeSource, props);
  });
  return _q.default.Promise.all(properties).then(function (propertyValues) {
    return propertyValues.reduce(function (decoratedUpgradeData, newProperty) {
      return (0, _extends2.default)({}, decoratedUpgradeData, newProperty);
    }, correctedUpgradeData);
  });
};

var createRenderBlockingUpgradeData = function createRenderBlockingUpgradeData() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return _createUpgradeData.apply(void 0, [RENDER_BLOCKING_PROPERTY_GETTERS].concat(args));
};

exports.createRenderBlockingUpgradeData = createRenderBlockingUpgradeData;

var createStaticUpgradeData = function createStaticUpgradeData() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return _createUpgradeData.apply(void 0, [STATIC_PROPERTY_GETTERS].concat(args));
};

exports.createStaticUpgradeData = createStaticUpgradeData;

var createLazyLoadedUpgradeData = function createLazyLoadedUpgradeData() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return _createUpgradeData.apply(void 0, [LAZY_LOADED_PROPERTY_GETTERS].concat(args));
};

exports.createLazyLoadedUpgradeData = createLazyLoadedUpgradeData;

var createUpgradeData = function createUpgradeData(upgradeData, upgradeSource, props) {
  return _createUpgradeData(RENDER_BLOCKING_PROPERTY_GETTERS, upgradeData, upgradeSource, props).then(function (renderBlockingUpgradeData) {
    return _createUpgradeData(LAZY_LOADED_PROPERTY_GETTERS, renderBlockingUpgradeData, props);
  });
};

exports.createUpgradeData = createUpgradeData;